<ng-container *ngIf="this.env.USE_TAILWIND; else elseBlock">
    <div id="splashScreen" [ngClass]="logoSplashBackgroundClass">
        <div
            class="[&>*]:h-full [&>*]:w-full [&>*]:max-w-full"
            [innerHTML]="logoSplash$ | async"
            aria-hidden="true"
            aria-label="{{ 'LOGO_ARIA_LABEL' | translate }}"></div>
    </div>
</ng-container>
<ng-template #elseBlock>
    <gl-splash-screen-legacy></gl-splash-screen-legacy>
</ng-template>
